module.exports = "https://coursera_assets.s3.amazonaws.com/images/a7b84c300acd6f6b247fde40e95ef1c0.png";